import { allevaOrangeColor } from '../../../../md/assets/jss/material-dashboard-pro-react';

const phoneInputStyle = {
  phoneInput: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  phoneInputLabel: {
    paddingTop: '4px',
    fontSize: '0.9rem',
  },
  phoneInputLabel_rqd: {
    paddingTop: '4px',
    fontSize: '0.9rem',
    color: `${allevaOrangeColor[0]}`,
  },
  labelsAndNumberDiv: {
    marginLeft: '20px',
    marginTop: '3px',
  },
  rolesRow: {
    marginLeft: '6px',
  },
  checkBoxStyle: {
    '& .MuiCheckbox-colorPrimary.Mui-checked': {
      color: `${allevaOrangeColor[0]} !important`,
    },
    zoom: 0.6,
  },
  checkboxLabel: {
    marginLeft: '-4px;',
    paddingRight: '2px',
    color: '#777',
    fontSize: '1.4rem',
  },
  numberInput: {
    marginTop: '-6px',
    marginLeft: '6px',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      width: '10.5em',
    },
  },
  nativeInput: {
    fontSize: '.92rem',
    '&:after': {
      borderBottom: '2px solid #9c27b0',
    },
  },
};

export default phoneInputStyle;
